import { useEffect, useRef } from 'react';
import { updateSessionStore } from '@hub/libs/catalog-service';
import { useRouter } from 'next/router';
import { useHasFocus } from '@hub/libs/useHasFocus';
import { SESSION_KEEP_ALIVE_TIMEOUT } from '@hub/libs/constants';
import { getSessionPayload } from '@hub/common/Session/session.utils';

export const useSessionStoreInitializer = () => {
  const router = useRouter();
  const { locale: localeStr } = router;
  const { language, country } = getSessionPayload(localeStr);
  const hasFocus = useHasFocus();
  const lastSessionUpdateRef = useRef<number>(0);

  useEffect(() => {
    const handleSessionUpdate = async () => {
      if (!router.isReady || !hasFocus) {
        return;
      }

      const isOutdated = Date.now() - lastSessionUpdateRef.current > SESSION_KEEP_ALIVE_TIMEOUT;
      if (!isOutdated) {
        return;
      }

      await updateSessionStore({ language, country });
      lastSessionUpdateRef.current = Date.now();
    };
    void handleSessionUpdate();
  }, [router.isReady, hasFocus]);
};
